<template>
  <div class="yxtbiz-ote-ai-ques-detail">
    <template v-if="create">
      <div class="mb8 color-gray-10 standard-size-14">
        {{ $t('pc_biz_ote_lbl_questiontype' /** 题型 */) }}
      </div>
      <div class="yxtbiz-ote-ai-ques-detail__type">
        <yxt-button
          v-for="item in typeList"
          :key="item.value"
          :type="item.value === currentComponent.type ? 'second' : ''"
          :class="item.value === currentComponent.type ? 'color-primary-6':'color-gray-9'"
          plain
          size="large"
          @click="changeType(item.value)"
        >
          <div class="flex flex-mid ">
            <yxt-svg
              width="16px"
              height="16px"
              :icon-class="item.iconClass"
              :remote-url="SvgMediaUrl"
              class="mr8"
            ></yxt-svg
            >{{ item.label }}
          </div>
        </yxt-button>
      </div>
    </template>

    <!-- 试题内容 -->
    <component
      v-bind:is="type[currentComponent.type]"
      :key="1"
      :ref="'currentComponentItem' + 1"
      :index="1"
      :currentComponent="currentComponent"
      :examType="examInfo.examType"
      :compTitle="compTitle"
      :isAudit="false"
      class="b-radius6"
      @resetCurrentComponent="resetCurrentComponent"
    ></component>
    <div class="mb8 color-gray-10 yxt-weight-5 standard-size-14">
      {{ $t('pc_biz_ote_lbl_topicsetting' /** 题目设置 */) }}
    </div>
    <div class="yxtbiz-ote-ai-ques-detail__setting">
      <yxt-form
        :model="currentComponent"
        :rules="rules"
        label-width="100px"
        label-position="top"
      >
        <div class="flex flex-wrap">
          <!-- 题库所在题库 -->
          <yxt-form-item
            class="yxtbiz-ote-ai-ques-detail__setting-lang"
            :label="$t('pc_biz_ote_lbl_quesbank')"
            prop="libId"
            size="small"
            :error="validateMsg.libMsg"
          >
            <yxt-select
              v-show="currentComponent.libName"
              v-model="currentComponent.libId"
              size="small"
              icon-name="more"
              value-key="libId"
              prop-label="libName"
              class="wp-100"
              hidden-option
              @visible-change="selLib"
            >
              <yxt-option
                :key="currentComponent.libId"
                :label="currentComponent.libName"
                :value="currentComponent.libId"
              ></yxt-option>
            </yxt-select>
          </yxt-form-item>
          <!-- 难度级别 -->
          <yxt-form-item
            :label="$t('pc_biz_ote_lbl_hardlevel')"
            prop="levelType"
            size="small"
            class="yxtbiz-ote-ai-ques-detail__setting-short"
          >
            <yxt-select
              v-model="currentComponent.levelType"
              :placeholder="$t('pc_biz_ote_lbl_all')"
              class="wp-100"
              size="small"
            >
              <yxt-option
                v-for="item in levelTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></yxt-option>
            </yxt-select>
          </yxt-form-item>
          <!-- 考核点（最多设置5个） -->
          <yxt-form-item
            size="small"
            :label="$t('pc_biz_ote_lbl_assessmentpoint')"
            class="yxtbiz-ote-ai-ques-detail__setting-lang"
          >
            <div class="wp-100 min-h-32">
              <ques-point-selector
                v-if="currentComponent.libId"
                v-model="currentComponent.pointIds"
                class="wp-100"
                selectClass="wp-100"
                :multiple-limit="pointNumLimit"
                :placeholder="$t('pc_biz_ote_lbl_pleaseselect3')"
                :libId="currentComponent.libId"
                selectSize="small"
              >
              </ques-point-selector>
            </div>
          </yxt-form-item>
        </div>
      </yxt-form>
    </div>
    <!-- 保存、取消 -->
    <div class="mt24 mb8">
      <yxt-button class="" type="primary" @click="saveForm()">{{
        $t('pc_biz_ote_lbl_save')
      }}</yxt-button>
      <yxt-button class="" @click="cancel()">{{
        $t('pc_biz_ote_btn_cancle')
      }}</yxt-button>
    </div>
    <!-- 选择题库 -->
    <yxt-drawer
      :title="$t('pc_biz_ote_msg_selqueslib')"
      :visible.sync="selectLibDrawerData.isShowSelectLibDrawer"
      size="960px"
      class="yxtbiz-lib-selector__select-drawer"
      :destroy-on-close="true"
      :before-close="
        done => done($refs.selectLib && $refs.selectLib.dialogEdited)
      "
    >
      <yxtbiz-lib-selector
        ref="selectLib"
        needCreateLib
        :createType="examId ? 1 : 0"
        :states="selectLibDrawerData"
        @selectLibCallback="selectLibCallback"
        @closeSelectLibDrawer="closeSelectLibDrawer"
      />
      <div slot="footer">
        <!--取 消-->
        <yxt-button plain @click="selectLibClose">{{
          $t('pc_biz_ote_btn_cancle')
        }}</yxt-button>
        <!--确 定-->
        <yxt-button type="primary" @click="selectLibSubmit">{{
          $t('pc_biz_ote_btn_confirm')
        }}</yxt-button>
      </div>
    </yxt-drawer>
  </div>
</template>
<script>
import LibSelector from 'yxt-biz-pc/packages/lib-selector';
import quesPointSelector from './quesPointSelector';

import quesCheckbox from './questionTypes/quesCheckbox';
import quesRadio from './questionTypes/quesRadio';
import quesCompletion from './questionTypes/quesCompletion';
import quesJudgment from './questionTypes/quesJudgment';
import quesShortAnswer from './questionTypes/quesShortAnswer';

import { SvgMediaUrl, QUES_LEVEL_NAMES, QUES_TYPE_NAMES } from '../const';
import {initQues} from '../utils';
import { getQuesLibDetail } from '../ques.service';

export default {
  components: {
    YxtbizLibSelector: LibSelector,
    quesCheckbox,
    quesRadio,
    Completion: quesCompletion,
    Judgment: quesJudgment,
    ShortAnswer: quesShortAnswer,
    quesPointSelector
  },
  props: {
    create: {
      type: Boolean,
      default: false
    },
    quesBody: {
      type: Object,
      default: () => {
        return {};
      }
    },
    libId: {
      type: String,
      default: ''
    },
    libName: {
      type: String,
      default: ''
    },
    examId: {
      type: String
    }
  },
  data() {
    // 试题库选择校验
    const validateLibId = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('pc_biz_ote_msg_selectqueslib')));
      }
    };
    // 必输校验（假装），只是为了展示红色必输标记；真正的校验会在点击保存时触发
    const validateStyle = callback => {
      callback();
    };
    return {
      SvgMediaUrl,
      currentComponent: {},
      editText: false,
      compTitle: [],
      examInfo: {
        status: 0,
        id: this.$route.query.id,
        name: '',
        examType: 0 // 试卷类型;0:试卷；1:练习
      },
      // 题型 0-单选题 1-多选题 2-判断题 3-填空题 4-问答题
      typeList: [
        {
          value: 0,
          iconClass: 'singlechoice',
          label: this.$t(QUES_TYPE_NAMES[0])
        },
        {
          value: 1,
          iconClass: 'multiplechoice',
          label: this.$t(QUES_TYPE_NAMES[1])
        },
        {
          value: 2,
          iconClass: 'judgment',
          label: this.$t(QUES_TYPE_NAMES[2])
        },
        {
          value: 3,
          iconClass: 'fillin',
          label: this.$t(QUES_TYPE_NAMES[3])
        },
        {
          value: 4,
          iconClass: 'shortanswer',
          label: this.$t(QUES_TYPE_NAMES[4])
        }
      ],
      type: [
        'quesRadio',
        'quesCheckbox',
        'Judgment',
        'Completion',
        'ShortAnswer'
      ], // 0：单选题；1：多选题；2：判断题；3：填空题；4：问答题；5：组合题
      validateMsg: {
        isShowError: false,
        libMsg: '', // 试题库
        contentMsg: '', // 题干
        choiceMsg: '' // 选择题选项
      },
      selectLibDrawerData: {
        isShowSelectLibDrawer: false,
        libId: '',
        libName: ''
      },
      id: '', // 试题ID
      pointNumLimit: 5, // 考核点数量上限5
      ques: null,
      // 考核点下拉框
      pointList: [],
      // 难度 0-易 1-中 2-难
      levelTypeList: QUES_LEVEL_NAMES.values.map((v) => ({ label: this.$t(QUES_LEVEL_NAMES[v]), value: v })),
      rules: {
        // 试题库必输校验
        libId: [{ required: true, validator: validateLibId, trigger: 'blur' }],
        // 题型（必输红色标记）
        quesType: [
          { required: true, validator: validateStyle, trigger: 'blur' }
        ],
        // 难度
        levelType: [
          { required: false, validator: validateStyle, trigger: 'blur' }
        ]
      },
      orgCode: window.localStorage.orgCode // 机构编号
    };
  },
  computed: {},
  mounted() {
    this.setInitDetail();
    this.getLibDetail(); // 获取试题库名称
  },
  methods: {
    changeType(t) {
      const ques = initQues(t, this.libId, this.libName || this.currentComponent.libName);
      ques.sourceType = 0;
      this.$emit('update:quesBody', ques);
      this.setInitDetail(ques);
    },
    setInitDetail(ques) {
      this.currentComponent = ques || this.quesBody;

      this.$forceUpdate();
    },
    selectLibClose() {
      this.$refs.selectLib.close();
    },
    selectLibSubmit() {
      this.$refs.selectLib.submit();
    },
    // 选择题库
    selLib(visible) {
      if (!visible) {
        return;
      }
      if (this.id) {
        return;
      }
      this.selectLibDrawerData.isShowSelectLibDrawer = true;
      this.selectLibDrawerData.libId = this.currentComponent.libId;
      this.selectLibDrawerData.libName = this.currentComponent.libName;
    },
    // 获取试题库详情
    getLibDetail() {
      if (this.currentComponent.libId) {
        getQuesLibDetail(this.currentComponent.libId).then(res => {
          this.currentComponent.libName = res.name;
          this.currentComponent.shared = res.shared;
        });
      }
    },

    // 验证校验
    validteSave() {
      const curItemRef = this.$refs['currentComponentItem' + 1];
      if (!curItemRef) return;

      const param = curItemRef.saveDetail();

      if (!param || param.error) return;

      return param;
    },
    // 保存
    saveForm() {
      this.$nextTick(() => {
        const param = this.validteSave();
        if (!param) return;

        this.$emit('save', param);
      });
    },
    // 返回
    cancel() {
      this.$emit('cancel');
    },
    resetCurrentComponent(val) {
      this.currentComponent = val;
    },
    // 选择题库回调
    selectLibCallback(libId, libName) {
      this.currentComponent.libId = libId;
      this.currentComponent.libName = libName;
      this.selectLibClose();
      this.changeLib();
    },
    // 变更试题库，重新加载考核点
    changeLib() {
      this.currentComponent.pointIds = [];
    },
    // 关闭选择题库抽屉
    closeSelectLibDrawer() {
      this.selectLibDrawerData.isShowSelectLibDrawer = false;
    }
  }
};
</script>
